(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-category-hero-slider"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-slider]').forEach(root=>{if(root.dataset.ready==='true')return;root.dataset.ready='true';const slides=Array.from(root.querySelectorAll('[data-slide]'));const dots=Array.from(root.querySelectorAll('[data-dot]'));if(slides.length<2)return;let current=0;let timer;const show=next=>{current=(next+slides.length)%slides.length;slides.forEach((slide,index)=>{const active=index===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true')});dots.forEach((dot,index)=>dot.classList.toggle('is-active',index===current))};const stop=()=>window.clearInterval(timer);const start=()=>{stop();if(root.dataset.autoplay==='true'&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){timer=window.setInterval(()=>show(current+1),Number(root.dataset.interval)||6000)}};root.querySelector('[data-prev]')?.addEventListener('click',()=>{show(current-1);start()});root.querySelector('[data-next]')?.addEventListener('click',()=>{show(current+1);start()});dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.dot));start()}));root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',start);start()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-vases"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
